module.exports = __webpack_public_path__ + "img/_cross-resonance_.2fe711c3.svg";